import React from 'react'
import { Link } from 'gatsby'
import Styles from '../../styles/main.module.css'
import "typeface-source-sans-pro"
import cx from 'classnames';

const Header = props => (
    <header className={cx(Styles.header, Styles.asterisk)}>
        <div className={cx(Styles.content, Styles.asterisk)}>
            <div className={cx(Styles.inner, Styles.asterisk)}>
                <h1 className={cx(Styles.asterisk, Styles.h1)}>Selamat Datang..</h1>
                <h4 className={cx(Styles.typewriter, Styles.asterisk, Styles.h4)}>Semangat Berproses</h4>
            </div>
        </div>
        <nav className={cx(Styles.nav, Styles.asterisk)}>
            <ul className={cx(Styles.ul, Styles.asterisk)}>
                <li className={cx(Styles.li, Styles.asterisk)}>
                    <a href="https://aryaaaarmdn.gitlab.io" title="Tentang Saya"
                        className={cx(Styles.a, Styles.asterisk)}>
                        Tentang Saya
                    </a>
                </li>
                <li className={cx(Styles.li, Styles.asterisk)}>
                    <Link to="/blog" title="Blog" className={cx(Styles.a, Styles.asterisk)}>Blog</Link>
                </li>
            </ul>
        </nav>
    </header>
)

export default Header